module.exports = __webpack_public_path__ + "img/pre.c695a199.svg";